const APP_NAME = process.env.APP_NAME || 'courtyard2'
const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV
const APP_IS_PROD = APP_ENV === 'prod'
const APP_IS_LOCAL = APP_ENV === 'local'
const APP_IS_PREVIEW = (process.env.VERCEL_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV) === 'preview'
const COMMIT_SHA = process.env.VERCEL_GIT_COMMIT_SHA || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || ''
const APP_REV = `${COMMIT_SHA}`.slice(0, 8)
const GQL_URI = process.env.NEXT_PUBLIC_UX_GQL_URI
const GQL_PUBLIC_URI = process.env.NEXT_PUBLIC_UX_GQL_PUBLIC_URI

// DEPLOYMENT
const DEPLOYED_URL =
  process.env.VERCEL_BRANCH_URL ||
  process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL ||
  process.env.VERCEL_URL ||
  process.env.NEXT_PUBLIC_VERCEL_URL
const APP_PREVIEW_BASE_URL = APP_IS_PREVIEW && DEPLOYED_URL ? `https://${DEPLOYED_URL}` : 'http://localhost:5012'

// FEATURE FLAGS
const DISABLE_PRE_LOAN_HUB_REDIRECT = process.env.DISABLE_PRE_LOAN_HUB_REDIRECT === 'true'
const ENABLE_PHOTO_UPLOAD = process.env.ENABLE_PHOTO_UPLOAD === 'true'
const MLM_ACCESS_ENABLED = process.env.MLM_ACCESS_ENABLED === 'true'
// Hard cutover flag: when true, Blend access is disabled for everyone and users
// are forced into the MeridianLink (LoanHub) flow. Independent of MLM_ACCESS_ENABLED.
const BLEND_ACCESS_DISABLED = process.env.BLEND_ACCESS_DISABLED === 'true'

// PHOTO UPLOAD SETTINGS
const PHOTO_UPLOAD_MAX_COUNT = Number(process.env.PHOTO_UPLOAD_MAX_COUNT) || 60

// AUTH
const AUTH0_AUDIENCE = process.env.AUTH0_AUDIENCE
// This is needed to support the nextjs-auth0 sdk. It should only be set for
// prod env and main branch for dev. All other deployments are Vercel URLs.
// It is also used below for APP_BASE_URL.
process.env.APP_BASE_URL = process.env.APP_BASE_URL || process.env.NEXT_PUBLIC_APP_BASE_URL || APP_PREVIEW_BASE_URL

const authApiPaths = {
  LOGIN: '/auth/login',
  LOGOUT: '/auth/logout',
  CALLBACK: '/auth/callback',
}

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL || APP_PREVIEW_BASE_URL
const GQL_PROXY_URI = `${APP_BASE_URL}/api/graphql`

const AUTH0_ISSUER_BASE_URL = process.env.AUTH0_ISSUER_BASE_URL
const PUBLIC_AUTH0_ISSUER_BASE_URL = process.env.NEXT_PUBLIC_AUTH0_ISSUER_BASE_URL
const PUBLIC_AUTH0_CLIENT_ID = process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID

// THIRDPARTY KEYS
const DISABLE_ALL_ANALYTICS = process.env.NEXT_PUBLIC_DISABLE_ALL_ANALYTICS === 'true'
const DD_CLIENT_TOKEN = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN
const DD_APPLICATION_ID = process.env.NEXT_PUBLIC_DD_APPLICATION_ID
const DD_ENABLED = DD_CLIENT_TOKEN && DD_APPLICATION_ID && !DISABLE_ALL_ANALYTICS
const HEAP_TOKEN = process.env.NEXT_PUBLIC_HEAP_TOKEN
const HEAP_PROXY = process.env.NEXT_PUBLIC_HEAP_PROXY === 'true'
const GTAG_ID = process.env.NEXT_PUBLIC_GTAG_ID
const APPZI_TOKEN = process.env.NEXT_PUBLIC_APPZI_TOKEN
const COOKIE_YES_SCRIPT_ID = process.env.NEXT_PUBLIC_COOKIE_YES_SCRIPT_ID

// FRONTYARD URLS
const FRONTYARD_URL = process.env.NEXT_PUBLIC_FRONTYARD_URL
const QUALIFY_URL = process.env.NEXT_PUBLIC_QUALIFY_URL
const TERRACE_URL = process.env.NEXT_PUBLIC_TERRACE_URL
const TERRACE_SIGNUP_URL = `${TERRACE_URL}/auth/signup`
const TERRACE_LOGIN_URL = `${TERRACE_URL}/login`
const FAQ_URL = `${FRONTYARD_URL}/faq`
const RESOURCE_CENTER = `${FRONTYARD_URL}/resources`
const LIVE_WEBINARS_URL = `${RESOURCE_CENTER}/category/live-webinars`
const TERMS_OF_USE_URL = `${FRONTYARD_URL}/terms-of-use`
const CONTACT_US_URL = `${FRONTYARD_URL}/contact`
const PRIVACY_POLICY_URL = `${FRONTYARD_URL}/privacy-policy`
const COOKIE_POLICY_URL = `${FRONTYARD_URL}/cookie-policy`
const DO_NOT_SELL_INFO_URL = `${FRONTYARD_URL}/privacy-policy#notice-for-california-residents`

// COURTYARD2 URLS
const COURTYARD2_AUTH_LOGIN_PATH = '/login'
const COURTYARD2_AUTH_SIGNUP_PATH = '/auth/signup'
const COURTYARD2_AUTH_SIGNUP_STEP2_PATH = '/auth/signup-step2'
const COURTYARD2_AUTH_SIGNUP_PATH_HOMEBUYER = '/auth/signup?audience=homebuyer'
const COURTYARD2_AUTH_LOGOUT_PATH = '/logout'
const COURTYARD2_EMAIL_VERIFY_PATH = '/auth/verify'
const COURTYARD2_ACCEPT_UPDATED_TERMS_PATH = '/auth/accept-updated-terms'
const COURTYARD2_HOME_DASHBOARD_PATH = '/dashboard'
const COURTYARD2_DOCUMENTS_PATH = '/documents'
const COURTYARD2_SET_LEAD_DATA_PATH = '/api/set-lead-data'
const COURTYARD2_LOAN_PATH = `/loan`
const COURTYARD2_PHOTOS_PATH = `/loan/property-photos`
const COURTYARD2_PROPERTY_DISCLOSURE_PATH = `/loan/property-disclosure`
const COURTYARD2_PROFILE_PATH = '/profile'
const LOAN_HUB_URL = '/loan-hub' // This is the user friendly version that redirects to blend in the redirect.js file
const PRE_LOAN_HUB_URL = DISABLE_PRE_LOAN_HUB_REDIRECT
  ? LOAN_HUB_URL
  : `${COURTYARD2_HOME_DASHBOARD_PATH}/before-you-get-started`
const DISBURSEMENTS_URL = `${COURTYARD2_HOME_DASHBOARD_PATH}/disbursements`

const BLEND_ROOT_URL = !APP_IS_PROD ? 'https://knock.beta.blendlabs.com' : 'https://loan.knock.com'
const BLEND_DOCUMENTS_URL = `${BLEND_ROOT_URL}/documents`

// MeridianLink Access (POS) routes + mode param values
const MLM_LOANHUB_PATH = '/loanhub'
const MLM_LOANHUB_REDIRECT_PATH = '/loanhub-redirect'
// Hostname of the MeridianLink Loan Hub destination. Used as an allowlist when
// redirecting — any URL returned from gql must match this host before we
// NextResponse.redirect to it, to prevent open-redirect abuse.
const MLM_LOANHUB_HOST = APP_IS_PROD ? 'loanhub.knock.com' : 'loanhub.dev.knock.com'
const MLM_MODE_LOGIN = 'login'
const MLM_MODE_SIGNUP = 'signup'
const MLM_MODE_GET_STARTED = 'getstarted'
const MLM_MODE_SECURITY_REQUEST = 'securityrequest'
// pointOfSale.vendor value used by Jupiter event JSON to identify MLM (LoanHub) customers
const POS_VENDOR_MORTGAGE_ACCESS = 'mortgage_access'
// pointOfSale.vendor value used by Jupiter event JSON to identify legacy Blend loans
const POS_VENDOR_BLEND = 'blend'

const LOGIN_WITH_REDIRECT_TO_COURTYARD2 = `${authApiPaths.LOGIN}?returnTo=${encodeURIComponent(APP_BASE_URL + COURTYARD2_HOME_DASHBOARD_PATH)}`
const LOGOUT_WITH_REDIRECT_TO_COURTYARD2_SIGNUP = `${authApiPaths.LOGOUT}?returnTo=${encodeURIComponent(APP_BASE_URL + COURTYARD2_AUTH_SIGNUP_PATH)}`
// Logging out from the loan hub landing page returns the user to that same page in
// login mode, so someone signed in as the wrong account can immediately sign back in
// as the right one instead of dead-ending on /signed-out.
const LOGOUT_WITH_REDIRECT_TO_LOANHUB_LOGIN = `${authApiPaths.LOGOUT}?returnTo=${encodeURIComponent(`${APP_BASE_URL}${MLM_LOANHUB_PATH}?mode=${MLM_MODE_LOGIN}`)}`

// LAYOUT/STYLING
const HEADER_HEIGHT_DESKTOP = 76
const HEADER_HEIGHT_MOBILE = 60
const SIDE_NAV_WIDTH_DESKTOP = 100
const SIDE_NAV_WIDTH_MOBILE = 275
const MOBILE_BREAKPOINT = '48em' // This matches the mobile breakpoint defined in the mantinev7 theme - default-theme

// COOKIES
const UNIVERSAL_LEAD_COOKIE = 'knock_universal_lead'
const KNOCK_BLEND_LOOP_COOKIE = 'knock_blend_loop'
const KNOCK_RETURN_TO_COOKIE = 'knock_return_to'
const COOKIE_YES_CONSENT_COOKIE = 'cookieyes-consent'
const KNOCK_PRIVACY_COOKIE = 'knock_privacy'
// Set on every successful Auth0 callback. Marks the browser as one that could
// still hold an Auth0 tenant session, which is what makes the silent SSO probe
// on /auth/signup worth running. See @phoenix-web/auth sso-probe.
const KNOCK_RETURNING_USER_COOKIE = 'knock_returning_user'
// Set when a probe came back with no Auth0 session, so we stop asking.
const KNOCK_SSO_PROBED_COOKIE = 'knock_sso_probed'

// Navigation
const BLEND_PARTY_TYPE_COBORROWER = 'coborrower'
const BLEND_SIGNUP_TYPE_PARAM = 'signup'
const BLEND_SIGNIN_TYPE_PARAM = 'signin'
const FIRST_VISIT_QUERY_PARAM = 'welcome'
const GET_SUPPORT_ANCHOR = '#get-support'
const COURTYARD2_HOME_DASHBOARD_WELCOME_PATH = `${COURTYARD2_HOME_DASHBOARD_PATH}?${FIRST_VISIT_QUERY_PARAM}=true`

const CORRESPONDENT = 'correspondent'
const MORTGAGE_BROKER = 'mortgage_broker'

// These blend app statuses are used in our "App Submitted" milestone and all of its related components/content
const BLEND_APP_SUBMITTED_STATUSES = ['SUBMITTED', 'TAKEN_OVER', 'FOLLOW_UP_ONLY']
const BLEND_APP_IN_PROGRESS_STATUSES = ['IN_PROGRESS', 'LENDER_SETUP']

export {
  APP_BASE_URL,
  APP_ENV,
  APP_IS_LOCAL,
  APP_IS_PROD,
  APP_NAME,
  APP_REV,
  APPZI_TOKEN,
  AUTH0_AUDIENCE,
  AUTH0_ISSUER_BASE_URL,
  authApiPaths,
  BLEND_ACCESS_DISABLED,
  BLEND_DOCUMENTS_URL,
  BLEND_PARTY_TYPE_COBORROWER,
  BLEND_SIGNIN_TYPE_PARAM,
  BLEND_SIGNUP_TYPE_PARAM,
  COOKIE_POLICY_URL,
  COOKIE_YES_CONSENT_COOKIE,
  COOKIE_YES_SCRIPT_ID,
  CONTACT_US_URL,
  CORRESPONDENT,
  COURTYARD2_AUTH_LOGIN_PATH,
  COURTYARD2_AUTH_SIGNUP_PATH,
  COURTYARD2_AUTH_SIGNUP_STEP2_PATH,
  COURTYARD2_AUTH_SIGNUP_PATH_HOMEBUYER,
  COURTYARD2_AUTH_LOGOUT_PATH,
  COURTYARD2_DOCUMENTS_PATH,
  COURTYARD2_EMAIL_VERIFY_PATH,
  COURTYARD2_ACCEPT_UPDATED_TERMS_PATH,
  COURTYARD2_HOME_DASHBOARD_PATH,
  COURTYARD2_HOME_DASHBOARD_WELCOME_PATH,
  COURTYARD2_LOAN_PATH,
  COURTYARD2_PHOTOS_PATH,
  COURTYARD2_PROFILE_PATH,
  COURTYARD2_PROPERTY_DISCLOSURE_PATH,
  COURTYARD2_SET_LEAD_DATA_PATH,
  DD_APPLICATION_ID,
  DD_CLIENT_TOKEN,
  DD_ENABLED,
  DISABLE_PRE_LOAN_HUB_REDIRECT,
  DISBURSEMENTS_URL,
  DISABLE_ALL_ANALYTICS,
  DO_NOT_SELL_INFO_URL,
  ENABLE_PHOTO_UPLOAD,
  FAQ_URL,
  FIRST_VISIT_QUERY_PARAM,
  FRONTYARD_URL,
  GET_SUPPORT_ANCHOR,
  GQL_PROXY_URI,
  GQL_PUBLIC_URI,
  GQL_URI,
  GTAG_ID,
  HEADER_HEIGHT_DESKTOP,
  HEADER_HEIGHT_MOBILE,
  HEAP_PROXY,
  HEAP_TOKEN,
  KNOCK_BLEND_LOOP_COOKIE,
  KNOCK_PRIVACY_COOKIE,
  KNOCK_RETURN_TO_COOKIE,
  KNOCK_RETURNING_USER_COOKIE,
  KNOCK_SSO_PROBED_COOKIE,
  LIVE_WEBINARS_URL,
  LOAN_HUB_URL,
  LOGIN_WITH_REDIRECT_TO_COURTYARD2,
  LOGOUT_WITH_REDIRECT_TO_COURTYARD2_SIGNUP,
  LOGOUT_WITH_REDIRECT_TO_LOANHUB_LOGIN,
  MLM_ACCESS_ENABLED,
  MLM_LOANHUB_HOST,
  MLM_LOANHUB_PATH,
  MLM_LOANHUB_REDIRECT_PATH,
  MLM_MODE_GET_STARTED,
  MLM_MODE_LOGIN,
  MLM_MODE_SECURITY_REQUEST,
  MLM_MODE_SIGNUP,
  MOBILE_BREAKPOINT,
  POS_VENDOR_BLEND,
  POS_VENDOR_MORTGAGE_ACCESS,
  PRE_LOAN_HUB_URL,
  PRIVACY_POLICY_URL,
  PUBLIC_AUTH0_CLIENT_ID,
  PUBLIC_AUTH0_ISSUER_BASE_URL,
  QUALIFY_URL,
  RESOURCE_CENTER,
  SIDE_NAV_WIDTH_DESKTOP,
  SIDE_NAV_WIDTH_MOBILE,
  TERMS_OF_USE_URL,
  TERRACE_URL,
  TERRACE_LOGIN_URL,
  TERRACE_SIGNUP_URL,
  UNIVERSAL_LEAD_COOKIE,
  MORTGAGE_BROKER,
  BLEND_APP_SUBMITTED_STATUSES,
  BLEND_APP_IN_PROGRESS_STATUSES,
  PHOTO_UPLOAD_MAX_COUNT,
}

//   TODO - Bring these back in here and turbo.json when ready
// const STORYBLOK_CDN_TOKEN = process.env.STORYBLOK_CDN_TOKEN

// ONLY CONSTANTS
// enum VALID_STORYBLOK_VERSIONS {
//   draft = 'draft',
//   published = 'published',
// }

// const STORYBLOK_VERSION = process.env.STORYBLOK_VERSION as VALID_STORYBLOK_VERSIONS
